import Box from '@mui/material/Box';
import React, { type JSX } from 'react';

import receiptIcon from 'app-components/assets/icons/receipts/receipt.svg';

type Props = {
  testId: string;
  tone?: 'default' | 'error';
};

const ReceiptImageFallback = ({ testId, tone = 'default' }: Props): JSX.Element =>
  tone === 'error' ? (
    <Box
      role='img'
      aria-label='Receipt image unavailable'
      data-testid={testId}
      sx={{
        width: 20,
        height: 20,
        bgcolor: 'error.dark',
        mask: `url(${receiptIcon}) center / contain no-repeat`,
        WebkitMask: `url(${receiptIcon}) center / contain no-repeat`,
      }}
    />
  ) : (
    <Box
      component='img'
      src={receiptIcon}
      alt='Receipt image unavailable'
      data-testid={testId}
      sx={{ width: 20, height: 20 }}
    />
  );

export default ReceiptImageFallback;
